import { EventTypes } from 'redux-segment';

import { QUICK_SALON_CREATION_COMPLETED } from './completeQuickCreation.types';

// eslint-disable-next-line max-len
// NOTE: This is needed to know exactly when the token has been refreshed and the quick salon creation could count as completed
const completeQuickCreation = () => ({
  type: QUICK_SALON_CREATION_COMPLETED,
  meta: { analytics: EventTypes.track },
});

// noinspection JSUnusedGlobalSymbols
export default completeQuickCreation;
